// A word counts as "mastered" once its spaced-repetition interval reaches ~3 weeks.
// Must match the backend's MASTERED_INTERVAL in utils/spacedRepetition.js.
export const MASTERED_INTERVAL = 21;
